import { Badge } from "reactstrap";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import { getStatusBadge } from "@helpers/utils";
import useDateHandler from "@hooks/use-date-handler";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const decoColumns = ({ handleRowActions, sendSurvey }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { dateFormatter } = useDateHandler();

    const handleNavigate = (survey_id) => {
        navigate(`/survey/response/${survey_id}`);
    };

    return [
        {
            name    : "Name",
            selector: (row) => row.name,
            width   : "400px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.name}
                    className="text-primary cursor-pointer"
                    id={`survey-title-${row._id}`}
                    onClick={() => handleNavigate(row._id)}
                    max={35}/>
            )
        },
        {
            name    : "Survey Type",
            selector: (row) => row.survey_type,
            width   : "200px",
            cell    : (row) => {
                const statusBadge = getStatusBadge(row.survey_type);
                return (
                    <Badge color={statusBadge?.color}>{t(statusBadge?.title)}</Badge>
                );
            }
        },
        {
            name    : "Created On",
            selector: (row) => row.createdAt,
            width   : "220px",
            cell    : (row) => (
                <span>
                    <i className="mdi mdi-calendar me-1 font-medium-3" />
                    {dateFormatter({
                        date    : row.createdAt,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </span>
            )
        },
        {
            name    : "Last Updated",
            selector: (row) => row.updatedAt,
            width   : "220px",
            cell    : (row) => (
                <span>
                    <i className="mdi mdi-calendar-edit me-1 font-medium-3" />
                    {dateFormatter({
                        date    : row.updatedAt,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </span>
            )
        },
        {
            name    : "Status",
            selector: (row) => row.status,
            width   : "150px",
            cell    : (row) => {
                const statusBadge = getStatusBadge(row.status);
                return (
                    <Badge color={statusBadge?.color}>{t(statusBadge?.title)}</Badge>
                );
            }
        },
        {
            name : "Actions",
            width: "250px",
            cell : (row) => {
                return (
                    <Flex>
                        <LoadingButton
                            outline
                            color="warning"
                            id={`${row._id}-send-button`}
                            tooltip={
                                t("Are you sure you want to send this survey?")
                            }
                            icon="send"
                            onClick={() => sendSurvey(row._id)}/>

                        <LoadingButton
                            outline
                            color="info"
                            id={`${row._id}-edit-button`}
                            icon="pencil"
                            onClick={() => handleRowActions(row, "edit")}/>
                        <LoadingButton
                            outline
                            color="danger"
                            id={`${row._id}-delete-button`}
                            icon="delete"
                            onClick={() => handleRowActions(row, "delete")}/>
                    </Flex>
                );
            }
        }
    ];
};
